import React, { Component } from "react";
import PropTypes from "prop-types";

import StoryMixerFeature from "react/views/storyMixer/StoryMixerFeature";
import StoryMixerResultContainer from "./StoryMixerResultsContainer";
import SearchByStoryElementsUrlBuilder from "lib/titleSearch/storyElements/SearchByStoryElementsUrlBuilder";
import * as StoryMixerSelector from "data/StoryMixerSelector";
import * as DataStore from "data/DataStore";
import {getStoryMixerOtsAvailability} from "data/OtsRequests";
import { attachFunctionToCallback } from "utility";
import { performJsonpGetRequest } from "lib/HttpRequest";
import {getPrimaryIsbn} from "data/TitleInfoSelector";
import './storyMixerFeatureContainer.less';
import GetStoryElementsByIsbnUrlBuilder from "lib/dataRetrieval/GetStoryElementsByIsbnUrlBuilder";

const storyMixerResultCallbackName = "storyMixerResultCallback";
const getStoryElementResultCallbackName = "getStoryElementResultCallback";

class StoryMixerFeatureContainer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoadingResults: false,
			storyMixerResultData: null,
			storyMixerCategoryList: null,
			willRender: false,
			selectedTerms: []
		};

		this.getTitlesBySelectedTerms = this.getTitlesBySelectedTerms.bind(this);
		this.fetchTitlesByTermList = this.fetchTitlesByTermList.bind(this);
		this.showStoryMixerResult = this.showStoryMixerResult.bind(this);
		this.getStoryElementsByIsbn = this.getStoryElementsByIsbn.bind(this);
		this.populateStoryElements = this.populateStoryElements.bind(this);

		attachFunctionToCallback(
			this.showStoryMixerResult,
			storyMixerResultCallbackName
		);

		attachFunctionToCallback(
			this.populateStoryElements,
			getStoryElementResultCallbackName
		);
	}

	componentWillMount() {
		this.initializeCategoryList();
	}

	showStoryMixerResult(data) {
		if (this.matchesCurrentSelectedTerms(data.Terms)) {
			
			getStoryMixerOtsAvailability(data);
			
			this.setState({
				isLoadingResults: false,
				storyMixerResultData: data
			});
		}
	}

	getTitlesBySelectedTerms() {
		let titleInfo = DataStore.getJsonData().TitleInfo;
		let profileData = DataStore.getProfileData();
		let url = new SearchByStoryElementsUrlBuilder().generateUrl(
			titleInfo.ui,
			this.state.selectedTerms,
			profileData);

		performJsonpGetRequest(url, storyMixerResultCallbackName);
	}

	populateStoryElements(data) {
		DataStore.setStoryElementsResult(data);
		this.storyMixerSubjectList = StoryMixerSelector.getStoryMixerCategories();
		const onNullRender = this.props.onNullRender;

		this.setState(
			{
				willRender: DataStore.hasData(this.storyMixerSubjectList)
			},
			() => {
				if (!this.state.willRender) {
					onNullRender();
				}
			}
		);
	}

	matchesCurrentSelectedTerms(terms) {
		let termsMatch = true;
		if(!terms){
			if( this.state.selectedTerms){
				termsMatch = this.state.selectedTerms.length === 0;
			}
		}
		else{
			termsMatch = this.state.selectedTerms.length === terms.length;

			if (termsMatch) {
				terms.forEach(term => {
					if (this.state.selectedTerms.indexOf(term) < 0) {
						termsMatch = false;
					}
				});
			}
		}

		return termsMatch;
	}

	initializeCategoryList() {
		if (DataStore.hasData(this.storyMixerSubjectList)) {
			this.setState(
				{
					willRender: true
				});
		}
		else {
			this.getStoryElementsByIsbn();
		}
	}

	getStoryElementsByIsbn() {
		if(DataStore.getJsonData() && DataStore.getJsonData().TitleInfo && DataStore.getProfileData()){
			let isbn = getPrimaryIsbn(DataStore.getJsonData());
			let profileData = DataStore.getProfileData();
			let url = new GetStoryElementsByIsbnUrlBuilder().generateUrl(profileData, isbn);

			performJsonpGetRequest(url, getStoryElementResultCallbackName);
		} else {
			// we have no data for the requested title, so we don't need to render StoryMixer
			this.props.onNullRender();
		}
	}

	isSelected(term) {
		return this.state.selectedTerms.includes(term);
	}

	handleSelectedTerm(term) {
		if (this.isSelected(term)) {
			this.removeTerm(term);
		} else {
			this.addTerm(term);
		}
	}

	addTerm(term) {
		this.setState({ selectedTerms: [...this.state.selectedTerms, term] },
			this.getTitlesBySelectedTerms);
	}

	removeTerm(term) {
		let filteredArray = this.state.selectedTerms.filter(item => item !== term);
		this.setState({ selectedTerms: filteredArray },
			this.getTitlesBySelectedTerms);
	}

	fetchTitlesByTermList(term) {
		this.setState({ isLoadingResults: true });
		this.handleSelectedTerm(term);
	}

	render() {
		const storyMixerCategoryList = StoryMixerSelector.getStoryMixerCategories();

		if (this.state.willRender) {
			return (
				//The top element of Carousel must have width set to 100% for onResize to be triggered
				<div className="story-mixer-container">
					<StoryMixerFeature
						storyMixerCategoryList={storyMixerCategoryList}
						handleClick={this.fetchTitlesByTermList}
					/>
					<StoryMixerResultContainer
						isLoading={this.state.isLoadingResults}
						storyMixerResultData={this.state.storyMixerResultData}
					/>
				</div>
			);
		} else {
			return null;
		}
	}
}

StoryMixerFeatureContainer.defaultProps = {
	onNullRender: () => { }
};

StoryMixerFeatureContainer.propTypes = {
	onNullRender: PropTypes.func
};

export default StoryMixerFeatureContainer;
export { attachFunctionToCallback };



// WEBPACK FOOTER //
// ./src/react/containers/StoryMixerFeatureContainer.jsx